// this file is generated by build/compile-schemas.js
import { validateCompiled, } from '../validator.js';
import { loginRequest, } from './AuthApi.generated.mjs';
import { loginRequestSchema, } from './AuthApi.js';
export function loginRequestValidate(props) {
    return validateCompiled(loginRequest, props);
}
import { loginResponse, } from './AuthApi.generated.mjs';
import { loginResponseSchema, } from './AuthApi.js';
export function loginResponseValidate(props) {
    return validateCompiled(loginResponse, props);
}
//# sourceMappingURL=AuthApi.binding.js.map